export default "__VITE_ASSET__3622594e__"